import { useMemo } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';

import { VacancyTo } from '../../types/routes.types';
import { mapVacancyTo } from '../../utils/navigation';
import { useLanguage } from '../useLanguage';

export interface CustomNavigateOptions<NavigateState> extends NavigateOptions {
  state: NavigateState;
}

export const useI18nNavigate = <LocationState>(): ((
  to: VacancyTo,
  navigateOptions?: CustomNavigateOptions<LocationState>
) => void) => {
  const navigateFunction = useNavigate();
  const { language } = useLanguage();

  return useMemo(
    () =>
      (to: VacancyTo, navigateOptions?: CustomNavigateOptions<LocationState>): void =>
        navigateFunction(mapVacancyTo(to, language), navigateOptions),
    [language, navigateFunction]
  );
};
